import { Link } from 'react-router-dom';

export function Terms() {
  return (
    <article className="mx-auto max-w-screen-md px-6 py-10 text-text-primary">
      <Link to="/" className="text-xs text-text-muted underline">← Home</Link>
      <h1 className="mt-4 text-2xl font-medium">Terms</h1>
      <p className="mt-3 text-sm text-text-muted">
        Nudge is provided as-is. Use it with kindness. By using the app you agree not to harass, abuse, or send unwanted messages to others. Misuse may result in account termination.
      </p>
      <p className="mt-3 text-sm text-text-muted">
        We reserve the right to change these terms; material changes will be communicated via the app.
      </p>
    </article>
  );
}
